















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {MenuStore} from '@/store/modules/menu.store';
import TPWebClientInternalHelpers, {ISlimOption, ISlimSelectedOption} from '@/TPWebClientInternal/helpers';
import {CartStore, ICartItemOption} from '@/store/modules/cart.store';
import {v4} from 'uuid';
import {ITicket, TicketStore} from '@/store/modules/ticket.store';
import {find} from 'lodash';
import {WebService} from '@/services/web.service';
import {OverlayShowTime} from '@/constants';
// @ is an alias to /src

@Component({
	components: {
	}
})
export default class ItemOptions extends Vue {
	@Prop({required: true})
	menuId!: string;

	@Prop({required: true})
	ticketId!: string;

	@Prop({required: true})
	itemId!: string;

	@Prop({default: null})
	cartItemId!: string | null;

	@Prop({default: null})
	lineItemId!: number | null;

	specialRequests = '';
	quantity = 1;
	selectedOptions: {
		[optionId: string]: string[];
	} = {};

	selectedCourse = 2;
	courses = [
		{
			courseId: 1,
			title: 'Starter /<br> Bring ASAP',
		},
		{
			courseId: 2,
			title: 'Main',
		},
		{
			courseId: 3,
			title: 'Dessert',
		}
	];

	showLoading = false;

	showOverlay = false;
	overlayMessage = '';

	promptOpen = false;

	get ticket() {
		return TicketStore.byId(this.ticketId);
	}

	get itemOptions() {
		return MenuStore.optionsForItem(this.itemId).sort((a, b) => {
			if(a.priority === b.priority) {
				return 0;
			}
			return a.priority > b.priority ? -1 : 1;
		});
	}

	get item() {
		return MenuStore.item(this.itemId);
	}

	itemOptionById(optionId: string) {
		return this.itemOptions.find((itemOption) => {
			return itemOption.optionId === optionId;
		});
	}

	@Watch('ticket', {immediate: true})
	async onTicketChange(currentTicket: ITicket | undefined, oldTicket: ITicket | undefined) {
		if(this.lineItemId !== null && currentTicket && currentTicket.lineItems !== null && !this.promptOpen && !this.showLoading) {
			this.promptOpen = true;
			const oldItem = oldTicket !== undefined && oldTicket.lineItems !== null ? oldTicket.lineItems.find((lineItem) => {
				return lineItem.lineItemId === this.lineItemId;
			}) || null : null;
			const currentItem = currentTicket.lineItems.find((lineItem) => {
				return lineItem.lineItemId === this.lineItemId;
			}) || null;

			if(currentItem == null) {
				await this.$bvModal.msgBoxOk( 'This item was deleted on another device.', {
					title: 'Item Deleted',
					centered: true,
					okTitle: 'Ok'
				});
				this.close();
			} else if(oldItem === null) {
				// How could this happen if we already have a lineItemId? Maybe first load? Ignore this
			} else {
				if(currentItem.modId !== oldItem.modId) {
					if(currentItem.status === 'CANCELLED') {
						await this.$bvModal.msgBoxOk( 'This item was deleted on another device.', {
							title: 'Item Deleted',
							centered: true,
							okTitle: 'Ok'
						});
						this.close();
					} else {
						await this.$bvModal.msgBoxOk( 'This item was edited on another device.', {
							title: 'Item Edited',
							centered: true,
							okTitle: 'Ok'
						});
						this.setSelectedOptions();
					}
				}
			}
			this.promptOpen = false;
		}
	}

	setSelectedOptions() {
		if(this.ticket && this.ticket.lineItems && this.lineItemId !== null) {
			const lineItem = find(this.ticket.lineItems, {
				lineItemId: this.lineItemId
			});
			if(lineItem) {
				this.specialRequests = lineItem.comments || '';
				this.selectedCourse = lineItem.courseId;
				lineItem.options.forEach((option) => {
					this.selectedOptions[option.optionId] = option.choices.map((choice) => {
						return choice.choiceId;
					});
				});
			}
		}
	}

	mounted() {
		if(this.cartItemId !== null) {
			const cartItem = CartStore.byId(this.cartItemId);
			if(cartItem) {
				this.specialRequests = cartItem.specialRequests || '';
				this.quantity = cartItem.quantity;
				this.selectedCourse = cartItem.courseId;
				cartItem.options.forEach((option) => {
					this.selectedOptions[option.optionId] = option.choices.map((choice) => {
						return choice.choiceId;
					});
				});
			}
		} else if(this.lineItemId !== null && this.ticket && this.ticket.lineItems !== null) {
			this.setSelectedOptions();
			// const lineItem = find(this.ticket.lineItems, {
			// 	lineItemId: this.lineItemId
			// });
			// if(lineItem) {
			// 	this.specialRequests = lineItem.comments || '';
			// 	this.selectedCourse = lineItem.courseId;
			// 	lineItem.options.forEach((option) => {
			// 		this.selectedOptions[option.optionId] = option.choices.map((choice) => {
			// 			return choice.choiceId;
			// 		});
			// 	});
			// }
		} else {
			if(this.item) {
				this.selectedCourse = this.item.defaultCourseId === null ? 2 : this.item.defaultCourseId;
			}
		}
	}

	@Watch('itemOptions', {immediate: true})
	setSelectOptions() {
		this.selectedOptions = this.itemOptions.reduce((selectedOptions: {[optionId: string]: string[]}, itemOption) => {
			if(!(itemOption.optionId in selectedOptions)) {
				selectedOptions[itemOption.optionId] = [];
			}
			if(this.lineItemId == null && this.cartItemId === null) {
				Object.values(itemOption.choices).forEach((choice) => {
					if(choice.selected) {
						selectedOptions[itemOption.optionId].push(choice.choiceId);
					}
				});
			}
			return selectedOptions;
		}, {});
	}

	isSelected(optionId: string, choiceId: string) {
		return this.selectedOptions[optionId] && this.selectedOptions[optionId].indexOf(choiceId) !== -1;
	}

	select(optionId: string, choiceId: string) {
		const itemOption = this.itemOptionById(optionId);
		if(itemOption) {
			const index = this.selectedOptions[optionId].indexOf(choiceId);
			if(index === -1) {
				if(itemOption.exclusive) {
					this.selectedOptions[optionId].shift();
					this.selectedOptions[optionId].push(choiceId);
				} else {
					this.selectedOptions[optionId].push(choiceId);
				}
			} else {
				this.selectedOptions[optionId].splice(index, 1);
			}
		}
	}

	get readyToAdd() {
		for(const itemOption of this.itemOptions) {
			if(itemOption.required && this.selectedOptions[itemOption.optionId] && this.selectedOptions[itemOption.optionId].length === 0) {
				return false;
			}
		}

		return true;
	}

	get totalCost() {
		if(this.item === null) {
			return 0;
		}
		const selectedOptions: ISlimSelectedOption[] = [];
		for(const optionId in this.selectedOptions) {
			if(this.selectedOptions.hasOwnProperty(optionId)) {
				selectedOptions.push({
					optionId: optionId,
					choices: this.selectedOptions[optionId].map((choiceId) => {
						return {
							choiceId: choiceId,
							quantity: 1
						};
					})
				});
			}
		}

		const itemOptions: ISlimOption[] = [];
		this.itemOptions.forEach((itemOption) => {
			itemOptions.push({
				optionId: itemOption.optionId,
				choices: Object.values(itemOption.choices),
				freeChoicesCount: itemOption.freeChoicesCount,
				price: itemOption.price,
			});
		});

		return TPWebClientInternalHelpers.calculatePrice(this.item, itemOptions, selectedOptions) * this.quantity;
	}

	close() {
		this.$emit('close');
	}

	removeBr(input: string) {
		return input.replace('<br>', '');
	}

	getCartOptions() {
		const options: ICartItemOption[] = [];
		for(const optionId in this.selectedOptions) {
			if(this.selectedOptions[optionId].length) {
				options.push({
					optionId: optionId,
					choices: this.selectedOptions[optionId].map((choiceId) => {
						return {
							choiceId: choiceId,
							quantity: 1
						};
					})
				});
			}
		}
		return options;
	}

	addToOrder() {
		CartStore.addOrUpdateItem({
			cartItemId: v4(),
			ticketId: this.ticketId,
			courseId: this.selectedCourse,
			menuId: this.menuId,
			itemId: this.itemId,
			options: this.getCartOptions(),
			quantity: this.quantity,
			specialRequests: this.specialRequests
		});
		this.close();
	}

	async updateLineItem() {
		this.$emit('beforeUpdate');
		try {
			this.showLoading = true;
			await WebService.updateLineItem(this.ticketId, {
				lineItemId: this.lineItemId as number,
				itemId: this.itemId,
				menuId: this.menuId,
				courseId: this.selectedCourse,
				comments: this.specialRequests,
				options: this.getCartOptions()
			});
			this.showLoading = false;
			this.$emit('afterUpdate');
			this.overlayMessage = `Item update`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk('There was a problem removing your item', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	updateCartItem() {
		CartStore.addOrUpdateItem({
			cartItemId: this.cartItemId || undefined,
			ticketId: this.ticketId,
			courseId: this.selectedCourse,
			menuId: this.menuId,
			itemId: this.itemId,
			options: this.getCartOptions(),
			quantity: this.quantity,
			specialRequests: this.specialRequests
		});
		this.close();
	}
}
